__turbopack_context__.v({
  "bottom": "SafeArea-module__sydQcW__bottom",
  "top": "SafeArea-module__sydQcW__top",
});
